import React from 'react';
import ParticipantsList from '../../../forum/components/participants/ParticipantsList';
import { Card, CardContent } from '../../../../components/ui/Card';

export default function TransactionParticipants({ transaction }) {
  const investors = transaction.participants?.filter(p => p.role === 'Investisseur' || p.role === 'Prêteur') || [];
  const borrowers = transaction.participants?.filter(p => p.role === 'Emprunteur' || p.role === 'Porteur') || [];
  const others = transaction.participants?.filter(p => p.role !== 'Investisseur' && p.role !== 'Prêteur' && p.role !== 'Emprunteur' && p.role !== 'Porteur') || [];

  return (
    <Card className="shadow-hp-sm">
      <CardContent className="p-6">
        <h3 className="mb-6 text-lg font-bold text-primary">Carnet des Intervenants</h3>
        
        <div className="grid grid-cols-1 gap-8 xl:grid-cols-2">
          <div>
            <h4 className="mb-4 border-b border-[var(--hp-color-border-muted)] pb-2 font-semibold text-[var(--hp-info-600)] dark:text-[var(--hp-info-400)]">
              Emprunteurs / Porteurs
            </h4>
            <ParticipantsList participants={borrowers} />
            {borrowers.length === 0 && (
              <p className="text-sm italic text-subtle">Aucun porteur défini.</p>
            )}
          </div>

          <div>
            <h4 className="mb-4 border-b border-[var(--hp-color-border-muted)] pb-2 font-semibold text-[var(--hp-success-600)] dark:text-[var(--hp-success-400)]">
              Investisseurs / Prêteurs
            </h4>
            <ParticipantsList participants={investors} />
            {investors.length === 0 && (
              <p className="text-sm italic text-subtle">Aucun investisseur engagé.</p>
            )}
          </div>
        </div>

        <div className="mt-8">
          <h4 className="mb-4 border-b border-[var(--hp-color-border-muted)] pb-2 font-semibold text-[var(--hp-color-text-subtle)]">
            Autres intervenants (Conseils, Notaires, Partenaires)
          </h4>
          <ParticipantsList participants={others} />
          {others.length === 0 && (
            <p className="text-sm italic text-subtle">Aucun autre intervenant.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
